// Estilos
import '../estilos/footer.css';


function footerSimple(){


    return( <div className="bg-dark text-light mt-5">
    <div className="container">
        <footer className="pt-5">
        
            {/* INFERIOR */}
            <div className="d-flex flex-column flex-sm-row justify-content-between py-4 border-top">
                <p>&copy; 2025 Zervicy. Todos los derechos resevados.</p>
                <p>Hecho por <a style={{textDecoration: "none"}} href="https://pretwor.com/" target="_blank" rel="noreferrer">Pretwor</a> y <a style={{textDecoration: "none"}} href="https://www.eduardoarias.co/" target="_blank" rel="noreferrer">Eduardo Arias</a>.</p>
            </div>
        </footer>
    </div>
    </div>
    )
}

export default footerSimple;